<template>
  <b-navbar-dropdown :label="companyName">
    <b-loading :is-full-page="false" :active.sync="isLoading" :can-cancel="true"></b-loading>
    <b-navbar-item 
      v-for="(company, index) in companies" 
      :key="company.id" 
      :index="index" 
      :href="company.siteUrl" 
    >
      {{company.companyName}} <span v-if="companyId == company.id">(current)</span>
    </b-navbar-item>
    
  </b-navbar-dropdown>
</template>

<script>
import {getHandler} from "./../../../../services/http.js"

export default {
  name: 'SitesDropdown',
  props:{
    companyName:{
        type: String,
        default: ""
    },
    companyId:{
      type:String,
      default:""
    },
    companiesEndpoint: {
        type:String,
        default:""
    }
  },

  data(){
    return{
      companies:[],
      isLoading:false
    }
  },
  methods: {
    async loadCompanies(){
        let errMsg = {
          text:"",
          hasIcon:true,
          resource:'notify'
        }
        this.isLoading = true
        this.companies = await getHandler(this.companiesEndpoint, {success:false, error:errMsg,})
        this.isLoading = false

    }
  },
  created(){
    this.loadCompanies()
  }
}
</script>

